import { IMusicProductPhysicalAlbum } from "services/music-product-physical/types/form";
import { IMusicProductPhysicalTrackResponse } from "services/music-product-physical/types/query";

interface ITracks {
  [key: number]: IMusicProductPhysicalAlbum;
}

export const convertTracksToAlbumsForm = (
  musicProductPhysicalTracks: IMusicProductPhysicalTrackResponse[]
) =>
  Object.values(
    musicProductPhysicalTracks.reduce<ITracks>((acc, album) => {
      if (!acc[album.albumNumber]) {
        acc[album.albumNumber] = { albumNumber: album.albumNumber, tracks: [] };
      }
      acc[album.albumNumber].tracks.push({
        id: album.trackId,
        name: album.title,
        isrc: album.isrc,
        mp3Link: album.mp3Link,
        mp3PreviewLink: album.mp3PreviewLink,
        wavLink: album.wavLink,
        flacLink: album.flacLink,
      });
      return acc;
    }, {})
  );
